import React, { useState, useEffect } from 'react';
// import Layout from '@/common/Layout';
import { Form, Card, Space, Input, Tag } from 'antd';
import FormItem from '@/common/FormItem';
import styles from '@/common/Layout/index.module.less';
import { getAllSuppliers } from '../../redux/slice';
import { vendorStatusLabel } from '../../vendorStatus.constants';
import CustomTable from 'common/Content/CustomTable';
import CustomButton from '@/common/CustomButton';
import { history } from 'app/history';
import Layout from '@/common/Layout';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { getLoggedInUser } from 'utilities/helpers';

const { Search } = Input;

const VendorsList = ({ loading }) => {
  const [form] = Form.useForm();
  const { user } = getLoggedInUser();

  //   const { allSamples } = useSelector((state) => state.stocks);
  const [allsuppliers, setAllsuppliers] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pagination, setPagination] = useState({});
  const [search, setSearch] = useState('');
  console.log(user);
  const dispatch = useDispatch();
  useEffect(() => {
    handleGetAllSuppliersDetails();
  }, [page, pageSize, search]);

  const handleGetAllSuppliersDetails = () => {
    const payload = { page: page, search: search, per_page: pageSize };
    dispatch(getAllSuppliers(payload)).then((response) => {
      if (response?.payload?.success) {
        setAllsuppliers(response?.payload?.data);
        setPagination(response?.payload?.pagination);
      }
    });
  };

  const handleChange = (e) => {
    setSearch(e.target.value);
    setPage(1);
  };

  //   console.log(allSamples);
  const columns = [
    {
      title: 'Supplier Name',
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
      width: '100px',
      render: (text, record) => {
        // return record?.qa_status == 'Pending' ? (
        return <a href={`/view-vendor?id=${record.id}&type=vendor`}>{text}</a>;
        // ) : (
        //   text
        // );
      }
    },
    {
      title: 'Manufacturer Name',
      dataIndex: 'manufacturer_name',
      key: 'manufacturer_name',
      ellipsis: true,
      width: '100px'
    },
    {
      title: 'Material Code',
      dataIndex: 'code',
      key: 'code',
      ellipsis: true,
      width: '100px',
      render: (_, record) => {
        return record?.material?.code;
      }
    },
    {
      title: 'Material Name',
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
      width: '100px',
      render: (_, record) => {
        return record?.material?.name;
      }
    },
    {
      title: 'Re-qualification Due',
      dataIndex: 'requalification_due',
      key: 'requalification_due',
      ellipsis: true,
      width: '100px',
      render: (_, record) => {
        return record?.requalification_due
          ? moment(record?.requalification_due).format('DD MMM YYYY')
          : 'NA';
      }
    },
    {
      title: 'QA Status',
      dataIndex: 'qa_status',
      key: 'qa_status',
      ellipsis: true,
      width: '100px',
      render: (text, record) => {
        return (
          <Tag
            color={
              record?.qa_status === 'Pending'
                ? '#007bff'
                : record?.qa_status === 'Rejected'
                ? '#dc3545'
                : record?.qa_status === 'Approved'
                ? '#28a745'
                : '#007bff'
            }
          >
            {record?.qa_status?.toUpperCase()}
          </Tag>
        );
      }
    },
    {
      title: 'Vendor Status',
      dataIndex: 'vendor_status',
      key: 'vendor_status',
      ellipsis: true,
      width: '100px',
      render: (text, record) => {
        return (
          <Tag
            color={
              record?.vendor_status === 'pending'
                ? '#007bff'
                : record?.vendor_status === 'rejected'
                ? '#dc3545'
                : record?.vendor_status === 'approved'
                ? '#28a745'
                : '#007bff'
            }
          >
            {vendorStatusLabel(record?.vendor_status)}
          </Tag>
        );
      }
    }
  ];

  return (
    <>
      <Layout sider={false}>
        <Form form={form} layout="vertical">
          <Card
            title={<span>Vendor Details</span>}
            className={` ${styles.cardStyles_approver}`}
            extra={
              <Space>
                <Search
                  onChange={(e) => handleChange(e)}
                  className={`w-100 ${styles.searchbar}`}
                  justify="start"
                  align="start"
                  placeholder="Search by Supplier Name, material Code,Material Name"
                />
                <CustomButton
                  className={styles.inwardButton}
                  onClick={() => history.push('/create-vendor')}
                  type="primary"
                >
                  Create
                </CustomButton>
              </Space>
            }
          >
            <div className={`${styles.table_container}`}>
              <CustomTable
                columns={columns}
                showPaginationMeta
                pagination={{
                  size: 'small',
                  total: pagination?.total_records || 0,
                  current: page,
                  pageSize: pageSize,
                  showSizeChanger: false,
                  onChange: (newPage, newSize) => {
                    if (newSize !== pageSize) {
                      setPageSize(newSize);
                      setPage(1);
                    } else {
                      setPage(newPage);
                    }
                  }
                }}
                dataSource={allsuppliers}
                loading={loading}
              />
            </div>
          </Card>
          <br />
          <FormItem className="text-center">
            <CustomButton
              className={styles.inwardButton}
              onClick={() => history.back()}
              type="primary"
            >
              Back to Home
            </CustomButton>
          </FormItem>
        </Form>
      </Layout>
    </>
  );
};
export default VendorsList;
